import React from 'react';
import { useParams } from 'react-router-dom';

import { useChainId } from '@occc-app/Chain/hooks';

import { useGetSegmentById } from '@occc/feat-segments';
import SegmentDetailsPage from './SegmentDetailsPage';

const SegmentDetailsPageContainer: React.FC = () => {
  const chainId = useChainId();
  const { id: segmentId = '' } = useParams<{ id: string }>();
  const { loading, error, data, refetch } = useGetSegmentById({
    idEquals: segmentId,
    chainIdEquals: chainId,
  });
  return (
    <SegmentDetailsPage loading={loading} error={error} segment={data} refetchSegments={refetch} />
  );
};

export default SegmentDetailsPageContainer;
